import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UuServicesComponent } from './uu-services/uu-services.component';
import { UuGoldStandardComponent } from './uu-gold-standard/uu-gold-standard.component';
import { UuOurExperinceComponent } from './uu-our-experince/uu-our-experince.component';
import { UuLocationsComponent } from './uu-locations/uu-locations.component';
import { UuDhsComponent } from './uu-dhs/uu-dhs.component';
import { UuHomepageComponent } from './uu-homepage/uu-homepage.component';
import { UuHeaderComponent } from './uu-header/uu-header.component';
import { UuServicesGraphicLinksComponent } from './uu-services-graphic-links/uu-services-graphic-links.component';
import { UuLeaderComponent } from './uu-leader/uu-leader.component';
import { ClientComponent } from './client/client.component';
import { AssociationsComponent } from './associations/associations.component';
import { CscStatsComponent } from './csc-stats/csc-stats.component';
import { UseUsHeaderVideoComponent } from './use-us-header-video/use-us-header-video.component';

const routes: Routes = [
  {path: '', component: UuHomepageComponent},
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  declarations: []
})
export class UseUsRoutingModule {
  static components = [
    UuServicesComponent,
    UuGoldStandardComponent,
    UuOurExperinceComponent,
    UuLocationsComponent,
    UuDhsComponent,
    UuHomepageComponent,
    UuHeaderComponent,
    UuServicesGraphicLinksComponent,
    UuLeaderComponent,
    ClientComponent,
    AssociationsComponent,
    CscStatsComponent,
    UseUsHeaderVideoComponent
  ];
 }
